<label class="ui-toggle" [class.ui-toggle--checked]="checked()" [class.ui-toggle--disabled]="disabled()">
  <input
    class="ui-toggle__input"
    type="checkbox"
    [checked]="checked()"
    [disabled]="disabled()"
    [attr.aria-label]="ariaLabel()"
    (change)="onToggle(toggleInput.checked)"
    #toggleInput
  />
  <span class="ui-toggle__track" aria-hidden="true">
    <span class="ui-toggle__thumb"></span>
  </span>
</label>
